import { _ as _extends } from '../../_rollupPluginBabelHelpers-c245b26a.js';
import { forwardRef } from 'react';
import 'focus-visible';
import { themed, getDefaultThemedOptions } from '@indeed/ifl-css';
import { FORM_SIZES } from '../../constants/index.js';
import transition from '../../utils/transition.js';
import createResponsive from '../../utils/createResponsive.js';
import { jsx } from '@emotion/react';
import { Label } from '../Label/Label.js';
import { Box } from '../Box/Box.js';
import '../../utils/styled.js';
import '../../utils/warnDeprecation.js';
import '../../utils/warn.js';
import '../VisuallyHidden/VisuallyHidden.js';

const labelSizes = {
  sm: "3",
  md: "sc3"
};
const sizes = {
  sm: 1.25,
  md: 1.5
};
const getSize = createResponsive(size => `${sizes[size]}rem`);
const getLabelPaddingBlock = createResponsive(size => labelSizes[size]);
const getDotSize = createResponsive(size => `${sizes[size] / 2}rem`);
const RadioInput = /*#__PURE__*/themed("input", process.env.NODE_ENV === "production" ? _extends({}, {
  target: "e1rw0n9c0"
}, getDefaultThemedOptions("inputSize", "invalid")) : _extends({}, {
  target: "e1rw0n9c0",
  label: "RadioInput"
}, getDefaultThemedOptions("inputSize", "invalid")))(_ref => {
  let {
    inputSize = "md",
    invalid
  } = _ref;
  return {
    appearance: "none",
    position: "relative",
    boxSizing: "border-box",
    inlineSize: getSize(inputSize),
    blockSize: getSize(inputSize),
    borderRadius: "full",
    borderWidth: 1,
    borderStyle: "solid",
    borderColor: invalid ? "border.status.critical.strong" : "border.action",
    bg: "background.action",
    cursor: "pointer",
    marginBlockStart: 0,
    marginBlockEnd: 0,
    marginInlineStart: 0,
    marginInlineEnd: 0,
    flexShrink: 0,
    transition: _ref2 => {
      let {
        transitions
      } = _ref2;
      return transition(transitions.default, "background-color", "border-color", "box-shadow");
    },
    "@media (prefers-reduced-motion: reduce)": {
      transition: "none"
    },
    "&:hover": {
      bg: "background.action.hover",
      borderColor: "border.action.hover"
    },
    "&:active": {
      bg: "background.action.active",
      borderColor: "border.action.active"
    },
    "&:focus": {
      outline: 0,
      boxShadow: "focus"
    },
    "&:focus:not([data-focus-visible-added])": {
      boxShadow: "none"
    },
    "&:after": {
      content: "''",
      position: "absolute",
      top: "50%",
      left: "50%",
      inlineSize: getDotSize(inputSize),
      blockSize: getDotSize(inputSize),
      borderRadius: "full",
      bg: "transparent",
      transform: "translate(-50%, -50%)",
      transition: _ref3 => {
        let {
          transitions
        } = _ref3;
        return `background-color ${transitions.default}`;
      },
      "@media (prefers-reduced-motion: reduce)": {
        transition: "none"
      }
    },
    // Selected
    "&:checked:after": {
      bg: "background.primary"
    }
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlJhZGlvLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUF5RG1CIiwiZmlsZSI6IlJhZGlvLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBSZWFjdCwgeyBmb3J3YXJkUmVmLCBJbnB1dEhUTUxBdHRyaWJ1dGVzIH0gZnJvbSBcInJlYWN0XCI7XG5pbXBvcnQgXCJmb2N1cy12aXNpYmxlXCI7XG5pbXBvcnQge1xuICB0aGVtZWQsXG4gIFN5c3RlbVN0eWxlT2JqZWN0LFxuICBnZXREZWZhdWx0VGhlbWVkT3B0aW9uc1xufSBmcm9tIFwiQGluZGVlZC9pZmwtY3NzXCI7XG5pbXBvcnQgeyBGb3JtU2l6ZSwgRk9STV9TSVpFUyB9IGZyb20gXCIuLi8uLi9jb25zdGFudHNcIjtcbmltcG9ydCB7IFN0eWxlUHJvcHMgfSBmcm9tIFwiLi4vLi4vdXRpbHMvc3R5bGVkXCI7XG5pbXBvcnQgdHJhbnNpdGlvbiBmcm9tIFwiLi4vLi4vdXRpbHMvdHJhbnNpdGlvblwiO1xuaW1wb3J0IGNyZWF0ZVJlc3BvbnNpdmUgZnJvbSBcIi4uLy4uL3V0aWxzL2NyZWF0ZVJlc3BvbnNpdmVcIjtcbmltcG9ydCB7IEJveCB9IGZyb20gXCIuLi9Cb3hcIjtcbmltcG9ydCB7IExhYmVsIH0gZnJvbSBcIi4uL0xhYmVsXCI7XG5cbmV4cG9ydCB0eXBlIFJhZGlvU2l6ZSA9IEZvcm1TaXplO1xuXG5leHBvcnQgaW50ZXJmYWNlIFJhZGlvUHJvcHNcbiAgZXh0ZW5kcyBTdHlsZVByb3BzLFxuICAgIE9taXQ8SW5wdXRIVE1MQXR0cmlidXRlczxIVE1MSW5wdXRFbGVtZW50PiwgXCJzaXplXCI+IHtcbiAgLyoqXG4gICAqIFN0eWxlcyB0aGUgcmFkaW8gdG8gcmVwcmVzZW50IGFuIGludmFsaWQgc3RhdGVcbiAgICovXG4gIGludmFsaWQ/OiBib29sZWFuO1xuICAvKipcbiAgICogVGV4dCBsYWJlbCBmb3IgdGhlIHJhZGlvLlxuICAgKi9cbiAgbGFiZWw/OiBzdHJpbmc7XG4gIC8qKlxuICAgKiBTaXplIG9mIHRoZSByYWRpby4gVXNlIHRoZSB2YWx1ZXMgYHNtYCBvciBgbWRgLlxuICAgKi9cbiAgc2l6ZT86IFJhZGlvU2l6ZSB8IFJhZGlvU2l6ZVtdO1xufVxuXG5jb25zdCBsYWJlbFNpemVzID0ge1xuICBzbTogXCIzXCIsXG4gIG1kOiBcInNjM1wiXG59O1xuXG5jb25zdCBzaXplcyA9IHtcbiAgc206IDEuMjUsXG4gIG1kOiAxLjVcbn07XG5cbmNvbnN0IGdldFNpemUgPSBjcmVhdGVSZXNwb25zaXZlPFJhZGlvU2l6ZSwgc3RyaW5nPihcbiAgc2l6ZSA9PiBgJHtzaXplc1tzaXplXX1yZW1gXG4pO1xuY29uc3QgZ2V0TGFiZWxQYWRkaW5nQmxvY2sgPSBjcmVhdGVSZXNwb25zaXZlPFJhZGlvU2l6ZT4oXG4gIHNpemUgPT4gbGFiZWxTaXplc1tzaXplXVxuKTtcbmNvbnN0IGdldERvdFNpemUgPSBjcmVhdGVSZXNwb25zaXZlPFJhZGlvU2l6ZSwgc3RyaW5nPihcbiAgc2l6ZSA9PiBgJHtzaXplc1tzaXplXSAvIDJ9cmVtYFxuKTtcblxudHlwZSBSYWRpb0lucHV0UHJvcHMgPSBSYWRpb1Byb3BzICYge1xuICBpbnB1dFNpemU6IFJhZGlvU2l6ZSB8IFJhZGlvU2l6ZVtdO1xufTtcblxuY29uc3QgUmFkaW9JbnB1dCA9IHRoZW1lZChcbiAgXCJpbnB1dFwiLFxuICBnZXREZWZhdWx0VGhlbWVkT3B0aW9ucyhcImlucHV0U2l6ZVwiLCBcImludmFsaWRcIilcbik8UmFkaW9JbnB1dFByb3BzPihcbiAgKHsgaW5wdXRTaXplID0gXCJtZFwiLCBpbnZhbGlkIH06IFJhZGlvSW5wdXRQcm9wcyk6IFN5c3RlbVN0eWxlT2JqZWN0ID0+ICh7XG4gICAgYXBwZWFyYW5jZTogXCJub25lXCIsXG4gICAgcG9zaXRpb246IFwicmVsYXRpdmVcIixcbiAgICBib3hTaXppbmc6IFwiYm9yZGVyLWJveFwiLFxuICAgIGlubGluZVNpemU6IGdldFNpemUoaW5wdXRTaXplKSxcbiAgICBibG9ja1NpemU6IGdldFNpemUoaW5wdXRTaXplKSxcbiAgICBib3JkZXJSYWRpdXM6IFwiZnVsbFwiLFxuICAgIGJvcmRlcldpZHRoOiAxLFxuICAgIGJvcmRlclN0eWxlOiBcInNvbGlkXCIsXG4gICAgYm9yZGVyQ29sb3I6IGludmFsaWQgPyBcImJvcmRlci5zdGF0dXMuY3JpdGljYWwuc3Ryb25nXCIgOiBcImJvcmRlci5hY3Rpb25cIixcbiAgICBiZzogXCJiYWNrZ3JvdW5kLmFjdGlvblwiLFxuICAgIGN1cnNvcjogXCJwb2ludGVyXCIsXG4gICAgbWFyZ2luQmxvY2tTdGFydDogMCxcbiAgICBtYXJnaW5CbG9ja0VuZDogMCxcbiAgICBtYXJnaW5JbmxpbmVTdGFydDogMCxcbiAgICBtYXJnaW5JbmxpbmVFbmQ6IDAsXG4gICAgZmxleFNocmluazogMCxcbiAgICB0cmFuc2l0aW9uOiAoeyB0cmFuc2l0aW9ucyB9KSA9PlxuICAgICAgdHJhbnNpdGlvbihcbiAgICAgICAgdHJhbnNpdGlvbnMuZGVmYXVsdCxcbiAgICAgICAgXCJiYWNrZ3JvdW5kLWNvbG9yXCIsXG4gICAgICAgIFwiYm9yZGVyLWNvbG9yXCIsXG4gICAgICAgIFwiYm94LXNoYWRvd1wiXG4gICAgICApLFxuICAgIFwiQG1lZGlhIChwcmVmZXJzLXJlZHVjZWQtbW90aW9uOiByZWR1Y2UpXCI6IHtcbiAgICAgIHRyYW5zaXRpb246IFwibm9uZVwiXG4gICAgfSxcbiAgICBcIiY6aG92ZXJcIjoge1xuICAgICAgYmc6IFwiYmFja2dyb3VuZC5hY3Rpb24uaG92ZXJcIixcbiAgICAgIGJvcmRlckNvbG9yOiBcImJvcmRlci5hY3Rpb24uaG92ZXJcIlxuICAgIH0sXG4gICAgXCImOmFjdGl2ZVwiOiB7XG4gICAgICBiZzogXCJiYWNrZ3JvdW5kLmFjdGlvbi5hY3RpdmVcIixcbiAgICAgIGJvcmRlckNvbG9yOiBcImJvcmRlci5hY3Rpb24uYWN0aXZlXCJcbiAgICB9LFxuICAgIFwiJjpmb2N1c1wiOiB7XG4gICAgICBvdXRsaW5lOiAwLFxuICAgICAgYm94U2hhZG93OiBcImZvY3VzXCJcbiAgICB9LFxuICAgIFwiJjpmb2N1czpub3QoW2RhdGEtZm9jdXMtdmlzaWJsZS1hZGRlZF0pXCI6IHtcbiAgICAgIGJveFNoYWRvdzogXCJub25lXCJcbiAgICB9LFxuICAgIFwiJjphZnRlclwiOiB7XG4gICAgICBjb250ZW50OiBcIicnXCIsXG4gICAgICBwb3NpdGlvbjogXCJhYnNvbHV0ZVwiLFxuICAgICAgdG9wOiBcIjUwJVwiLFxuICAgICAgbGVmdDogXCI1MCVcIixcbiAgICAgIGlubGluZVNpemU6IGdldERvdFNpemUoaW5wdXRTaXplKSxcbiAgICAgIGJsb2NrU2l6ZTogZ2V0RG90U2l6ZShpbnB1dFNpemUpLFxuICAgICAgYm9yZGVyUmFkaXVzOiBcImZ1bGxcIixcbiAgICAgIGJnOiBcInRyYW5zcGFyZW50XCIsXG4gICAgICB0cmFuc2Zvcm06IFwidHJhbnNsYXRlKC01MCUsIC01MCUpXCIsXG4gICAgICB0cmFuc2l0aW9uOiAoeyB0cmFuc2l0aW9ucyB9KSA9PlxuICAgICAgICBgYmFja2dyb3VuZC1jb2xvciAke3RyYW5zaXRpb25zLmRlZmF1bHR9YCxcbiAgICAgIFwiQG1lZGlhIChwcmVmZXJzLXJlZHVjZWQtbW90aW9uOiByZWR1Y2UpXCI6IHtcbiAgICAgICAgdHJhbnNpdGlvbjogXCJub25lXCJcbiAgICAgIH1cbiAgICB9LFxuICAgIC8vIFNlbGVjdGVkXG4gICAgXCImOmNoZWNrZWQ6YWZ0ZXJcIjoge1xuICAgICAgYmc6IFwiYmFja2dyb3VuZC5wcmltYXJ5XCJcbiAgICB9XG4gIH0pXG4pO1xuXG4vKipcbiAqIEBzZWUgaHR0cHM6Ly9leHBlcmllbmNlLmluZGVlZC5kZXNpZ24vY29tcG9uZW50cy9pZHMvcmFkaW9cbiAqL1xuZXhwb3J0IGNvbnN0IFJhZGlvID0gZm9yd2FyZFJlZjxIVE1MSW5wdXRFbGVtZW50LCBSYWRpb1Byb3BzPihcbiAgKFxuICAgIHtcbiAgICAgIGFzID0gXCJsYWJlbFwiLFxuICAgICAgY2xhc3NOYW1lLFxuICAgICAgY2hpbGRyZW4sXG4gICAgICBkaXNhYmxlZCxcbiAgICAgIGlkLFxuICAgICAgaW52YWxpZCxcbiAgICAgIGxhYmVsLFxuICAgICAgc2l6ZSA9IFwibWRcIixcbiAgICAgIHN4LFxuICAgICAgLi4ucHJvcHNcbiAgICB9LFxuICAgIHJlZlxuICApID0+IChcbiAgICA8TGFiZWxcbiAgICAgIGFzPXthc31cbiAgICAgIGh0bWxGb3I9e2lkfVxuICAgICAgZGlzYWJsZWQ9e2Rpc2FibGVkfVxuICAgICAgc2l6ZT17c2l6ZX1cbiAgICAgIGNsYXNzTmFtZT17Y2xhc3NOYW1lfVxuICAgICAgc3g9e3tcbiAgICAgICAgZGlzcGxheTogXCJmbGV4XCIsXG4gICAgICAgIGZvbnRXZWlnaHQ6IFwibm9ybWFsXCIsXG4gICAgICAgIHBvc2l0aW9uOiBcInJlbGF0aXZlXCIsXG4gICAgICAgIHBhZGRpbmdCbG9ja1N0YXJ0OiBnZXRMYWJlbFBhZGRpbmdCbG9jayhzaXplKSxcbiAgICAgICAgcGFkZGluZ0Jsb2NrRW5kOiBnZXRMYWJlbFBhZGRpbmdCbG9jayhzaXplKSxcbiAgICAgICAgY3Vyc29yOiBcInBvaW50ZXJcIixcbiAgICAgICAgLi4uc3hcbiAgICAgIH19PlxuICAgICAgPFJhZGlvSW5wdXRcbiAgICAgICAgaWQ9e2lkfVxuICAgICAgICByZWY9e3JlZn1cbiAgICAgICAgdHlwZT1cInJhZGlvXCJcbiAgICAgICAgaW5wdXRTaXplPXtzaXplfVxuICAgICAgICBkaXNhYmxlZD17ZGlzYWJsZWR9XG4gICAgICAgIGludmFsaWQ9e2ludmFsaWR9XG4gICAgICAgIGFyaWEtaW52YWxpZD17aW52YWxpZH1cbiAgICAgICAgey4uLnByb3BzfVxuICAgICAgLz5cbiAgICAgIHtjaGlsZHJlbiB8fCBsYWJlbCA/IChcbiAgICAgICAgPEJveCBhcz1cInNwYW5cIiBzeD17eyBmbGV4R3JvdzogMSwgbWFyZ2luSW5saW5lU3RhcnQ6IDMgfX0+XG4gICAgICAgICAge2NoaWxkcmVuIHx8IGxhYmVsfVxuICAgICAgICA8L0JveD5cbiAgICAgICkgOiBudWxsfVxuICAgIDwvTGFiZWw+XG4gIClcbik7XG5cbmV4cG9ydCBjb25zdCBSQURJT19TSVpFUyA9IEZPUk1fU0laRVMgYXMgUmFkaW9TaXplW107XG5cblJhZGlvLmRpc3BsYXlOYW1lID0gXCJSYWRpb1wiO1xuIl19 */");

/**
 * @see https://experience.indeed.design/components/ids/radio
 */
const Radio = /*#__PURE__*/forwardRef((_ref4, ref) => {
  let {
    as = "label",
    className,
    children,
    disabled,
    id,
    invalid,
    label,
    size = "md",
    sx,
    ...props
  } = _ref4;
  return jsx(Label, {
    as: as,
    htmlFor: id,
    disabled: disabled,
    size: size,
    className: className,
    sx: {
      display: "flex",
      fontWeight: "normal",
      position: "relative",
      paddingBlockStart: getLabelPaddingBlock(size),
      paddingBlockEnd: getLabelPaddingBlock(size),
      cursor: "pointer",
      ...sx
    }
  }, jsx(RadioInput, _extends({
    id: id,
    ref: ref,
    type: "radio",
    inputSize: size,
    disabled: disabled,
    invalid: invalid,
    "aria-invalid": invalid
  }, props)), children || label ? jsx(Box, {
    as: "span",
    sx: {
      flexGrow: 1,
      marginInlineStart: 3
    }
  }, children || label) : null);
});
const RADIO_SIZES = FORM_SIZES;
Radio.displayName = "Radio";

export { RADIO_SIZES, Radio };
